import React from "react";
import { ArrowUpRight } from "lucide-react";

interface FinalCtaSectionProps {
  onCreateClick: () => void;
  onHowItWorksClick: () => void;
}

const FinalCtaSection: React.FC<FinalCtaSectionProps> = ({
  onCreateClick,
  onHowItWorksClick,
}) => {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      {/* Header */}
      <div className="max-w-2xl mb-12 md:mb-16">
        <span className="ed-eyebrow mb-5 block text-[var(--ed-paper)]/60">
          07 — Passer à l'action
        </span>
        <h2 className="ed-heading text-3xl md:text-5xl lg:text-6xl mb-6 text-[var(--ed-paper)]">
          Votre ville mérite{" "}
          <span className="italic font-light text-[var(--ed-paper)]/70">
            mieux qu'un formulaire papier.
          </span>
        </h2>
        <p className="ed-subtle text-base md:text-lg leading-relaxed max-w-lg text-[var(--ed-paper)]/60">
          Trente secondes pour signaler. Quelques jours pour voir bouger les
          choses. Une habitude citoyenne à reprendre, ensemble.
        </p>
      </div>

      {/* Editorial statement line */}
      <div className="ed-fade-up" style={{ animationDelay: "120ms" }}>
        <div className="h-px w-full bg-[var(--ed-paper)]/15 mb-10 md:mb-14" />

        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-end">
          {/* Left — numeric anchor */}
          <div className="md:col-span-4">
            <div className="ed-numeric text-5xl md:text-6xl text-[var(--ed-paper)] mb-2">
              30s
            </div>
            <p className="font-display text-[10px] uppercase tracking-[0.28em] text-[var(--ed-paper)]/50">
              Pour signaler
            </p>
          </div>

          {/* Middle — actions */}
          <div className="md:col-span-8 flex flex-col sm:flex-row gap-4 md:gap-6 md:justify-end">
            <button
              onClick={onCreateClick}
              className="group inline-flex items-center justify-center gap-3 px-7 py-4 bg-[var(--ed-paper)] text-[var(--ed-ink)] font-display font-semibold text-sm tracking-tight rounded-none border border-[var(--ed-paper)] hover:bg-transparent hover:text-[var(--ed-paper)] transition-all duration-500"
            >
              Faire un signalement
              <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </button>

            <button
              onClick={onHowItWorksClick}
              className="group inline-flex items-center justify-center gap-3 px-7 py-4 bg-transparent text-[var(--ed-paper)] font-display font-semibold text-sm tracking-tight rounded-none border border-[var(--ed-paper)]/30 hover:border-[var(--ed-paper)] transition-all duration-500"
            >
              Comment ça marche
              <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </button>
          </div>
        </div>

        <div className="h-px w-full bg-[var(--ed-paper)]/15 mt-10 md:mt-14" />
      </div>

      {/* Editorial footer line */}
      <div className="mt-10 md:mt-14 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="flex items-center gap-6">
          <div className="h-px w-16 bg-[var(--ed-paper)]/40" />
          <span className="text-xs text-[var(--ed-paper)]/40 font-body tracking-wide">
            Gratuit · Sans publicité · Données protégées
          </span>
        </div>
        <span className="ed-numeric text-xs text-[var(--ed-paper)]/30">
          KLIKAN · Civic tech française · 2026
        </span>
      </div>
    </div>
  );
};

export default FinalCtaSection;
